import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { Auth } from '@angular/fire/auth';
import { AuthService } from "./auth.service";
import { NavController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  authService = inject(AuthService);
  fireAuth = inject(Auth);
  constructor(
    private navCtrl: NavController,
  ) {}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const user = await this.authService.getUser();

      // Debug
      console.log("AuthGuard next:", next);
      console.log("AuthGuard state:", state);

      if (user) {
        // User eingeloggt
        return true;
      }

      // Kein User eingeloggt
      console.log("User is not logged in");

      // Join-Parameter merken
      if (state.url.includes("join") && next.queryParams && next.queryParams["id"]) {
        localStorage.setItem("joinId", next.queryParams["id"]);
      }

      // Logout war explizit getriggert
      if (this.authService.logoutTriggered) {
        this.authService.logoutTriggered = false;
        await this.navCtrl.navigateRoot(["home"]);
        return false;
      }

      // Normaler Unauth-Fall → auf Login schicken
      await this.navCtrl.navigateForward(["login"]);
      return false;

    } catch (err) {
      console.error("AuthGuard error", err);
      await this.navCtrl.navigateForward(["login"]);
      return false;
    }
  }
}
